<footer>
  <div class="footer-action">
    <button mat-fab color="primary"
            class="action-btn"
            [disabled]="loading"
            (click)="onActionClick()">
      <span class="action-btn-icon action-btn-icon--{{ actionType.toLowerCase() }}"></span>
    </button>
    <span class="action-text">{{ btnTextTranslates[actionType] | translate }}</span>
  </div>
</footer>

